import { useEffect } from "react";
import { useRouter } from "next/router";
import { gaProxy } from "../../utils/functionProxy";
import routes from "../../routes";
import Script from "next/script";

declare global {
  interface Window {
    ga: Function;
  }
}

const GAReport = () => {
  const router = useRouter();
  const pagename = router.pathname;
  const gaParams =
    routes.find((item) => item.path === pagename)?.gaParams || {};
  const { group1 } = gaParams;
  return (
    <>
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=UA-93025844-24`}
      />
      <Script
        id="gtag-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'UA-93025844-24', {
              'content_group1': "${group1 || "other"}"
            });
            gtag('config', 'G-LTBZJ0RX7G', {
              'content_group1': "${group1 || "other"}"
            });
          `,
        }}
      />
    </>
  );
};
export default GAReport;
